export const formatColumnValue = (value, column) => {
    if (value === null || value === undefined || value === '') return 'N/A';
    return column.format ? column.format(value) : value;
};
